import { render, staticRenderFns } from "./OrderGeneralTemplate.vue?vue&type=template&id=130db8b4&lang=pug"
import script from "./OrderGeneralTemplate.vue?vue&type=script&lang=js"
export * from "./OrderGeneralTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports